import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { DataService } from '../services/data.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class IsLoggedInGuard implements CanActivate {
  constructor(
    private router:Router,
    public dataService: DataService
  ){

    }
  canActivate(
    
   ){
    
    return this.dataService.getStoredData({key:"newUser"}).then(value=>{
      return this.dataService.getStoredData({key:environment.clientsKey}).then(clients=>{
        if(!clients && !value){
          
          
          return this.router.parseUrl('/welcome')
        }
        else if(clients && !value){
          return this.router.parseUrl('/welcome')
        }
           else{
           
            if(value.stepOneComplete == false && value.stepTwoComplete == false){
             
              return this.router.parseUrl('/welcome')
            } else if(value.stepOneComplete == true && value.stepTwoComplete == false){
            
              return this.router.parseUrl('/chooseclient')
            }
             else if(value.stepOneComplete == true && value.stepTwoComplete == true){
              if(this.dataService.isAuthenticated.value){
                return this.router.parseUrl('/home')
              } else {
                return true
              }
            }
          }
        
    
  })})
    
  }
  
}
